import { MoleculeFormStepResumeSliceProps } from 'wolf/components/molecules/m-formstep-resume-slice/m-formstep-resume-slice.data';
import { FormstepWarrantyStep2Events } from 'wolf/components/molecules/m-formstep-warranty-step-2/m-formstep-warranty-step-2.events';
import { FormstepWarrantyStep3Events } from 'wolf/components/molecules/m-formstep-warranty-step-3/m-formstep-warranty-step-3.events';
import { FormstepWarrantyWolfProductsEvents } from 'wolf/components/molecules/m-formstep-warranty-wolf-products/m-formstep-warranty-wolf-products.events';
import { ComponentEvents } from '../../../../global/interfaces/component.interface';
import { FormstepSelectImageEvents } from "../../molecules/m-formstep-select-image/m-formstep-select-image.events";
import {FormstepSelectIconEvents} from "../../molecules/m-formstep-select-icon/m-formstep-select-icon.events";

/**
 * Support for differentiating between the type of successful
 * validation events triggered by FE or BE validation events
 * Note: treat as bitwise flags so we can set them!
 */
export enum FormStepperValidationEventClientServerEnum {
	/** Events carried out on the client, in the frontend controllers */
	Frontend = 1,
	/** Events carried out on the backend API */
	Backend = 2,
	// Another = 4,
}

export interface FormStepperValidationEvent {
	onValidationSuccess: (validationLocation?: FormStepperValidationEventClientServerEnum, resumeSlice?: MoleculeFormStepResumeSliceProps) => void;
	onValidationError: (validationLocation?: FormStepperValidationEventClientServerEnum) => void;
	currentStep: number;
}


const EVENT_PREFIX = 'FormStepperEvents__';

/** The type of custom events emitted in event.detail */
export type OrganismFormStepperEventTypes = {
	DISABLE_GO_TO_NEXT_STEP: boolean;
	ENABLE_GO_TO_NEXT_STEP: boolean;
	RECEIVE_RESUME_SLICE: ResumeSliceSummary[];
	REQUEST_GO_TO_STEP: number;
	RECEIVE_CONTROLLED_FORM_SLICE: ControlledFormSlice;
	REMOVE_CONTROLLED_FORM_SLICE: ControlledFormSlice;
	FORM_DATA_CHANGED_BY_STEP: number;
	RESET_VALIDATION_SCORE_BY_STEP: number;
};

/** The event names for the above events */
export const OrganismFormStepperEvents: ComponentEvents<OrganismFormStepperEventTypes> = {
	/** If true, the 'next step' button is disabled */
	DISABLE_GO_TO_NEXT_STEP: EVENT_PREFIX + 'DisableNextStep',
	ENABLE_GO_TO_NEXT_STEP: EVENT_PREFIX + 'EnableNextStep',
	RECEIVE_RESUME_SLICE: EVENT_PREFIX + 'ReceiveResumeSlice',
	REQUEST_GO_TO_STEP: EVENT_PREFIX + 'RequestGoToStep',
	RECEIVE_CONTROLLED_FORM_SLICE: EVENT_PREFIX + 'ReceiveControlledFormSlice',
	REMOVE_CONTROLLED_FORM_SLICE: EVENT_PREFIX + 'RemoveControlledFormSlice',
	FORM_DATA_CHANGED_BY_STEP:  EVENT_PREFIX + 'FormDataChangedByStep',
	RESET_VALIDATION_SCORE_BY_STEP: EVENT_PREFIX + 'ResetValidationScoreByStep',
};


export interface ResumeSliceSummary {
	step: number;
	resumeSlices: MoleculeFormStepResumeSliceProps[]
}

export interface ControlledFormSlice {
	stepId: string;
	formSlice: Record<string, string>
}

export type ValidationClientsideEventController = 'm-formstep-warranty-wolf-products' | 'm-formstep-warranty-step-2' | 'm-formstep-warranty-step-3' | 'm-formstep-select-image' | 'm-formstep-select-icon';

export const ValidationEventMapper: Record<ValidationClientsideEventController, string> = {
	'm-formstep-warranty-wolf-products': FormstepWarrantyWolfProductsEvents.REQUEST_VALIDATION,
	'm-formstep-warranty-step-2': FormstepWarrantyStep2Events.REQUEST_VALIDATION,
	'm-formstep-warranty-step-3': FormstepWarrantyStep3Events.REQUEST_VALIDATION,
	'm-formstep-select-image': FormstepSelectImageEvents.REQUEST_VALIDATION,
	'm-formstep-select-icon': FormstepSelectIconEvents.REQUEST_VALIDATION,
};
